<script setup lang="ts">
const props = defineProps<{
  modelValue: string | null
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const left = ref('')
const right = ref('')

// Sync from parent value
watch(() => props.modelValue, (val) => {
  if (val && val.includes('/')) {
    const parts = val.split('/')
    left.value = parts[0] ?? ''
    right.value = parts[1] ?? ''
  } else {
    left.value = ''
    right.value = ''
  }
}, { immediate: true })

function sanitize(val: string): string {
  return val.replace(/[^a-zA-Z]/g, '')
}

function onInput() {
  left.value = sanitize(left.value)
  right.value = sanitize(right.value)
  const combined = left.value || right.value
    ? `${left.value}/${right.value}`
    : ''
  emit('update:modelValue', combined)
}
</script>

<template>
  <div class="inline-flex items-center gap-0.5">
    <input
      v-model="left"
      type="text"
      maxlength="20"
      placeholder="she"
      class="w-12 bg-transparent text-center text-xs text-white/40 outline-none border-b border-dashed border-white/10 focus:border-white/30 transition-colors placeholder:text-white/15"
      @input="onInput"
    >
    <span class="text-xs text-white/20 select-none">/</span>
    <input
      v-model="right"
      type="text"
      maxlength="20"
      placeholder="her"
      class="w-12 bg-transparent text-center text-xs text-white/40 outline-none border-b border-dashed border-white/10 focus:border-white/30 transition-colors placeholder:text-white/15"
      @input="onInput"
    >
  </div>
</template>
